import React from "react";
import { StatusToggleSwitch } from "../../../../StatusToggleSwitch";
import { inactiveObjective } from "../../../../../redux/features/assessmentToolSlice";

const StatusSwitch = ({ params }) => {
    return (
        <StatusToggleSwitch
            disabled={params.has_child_element === 1 ? true : false}
            api={inactiveObjective(params.objective_id)}
            initialValue={params.objective_status === 0 ? true : false}
        />
    );
};

export default StatusSwitch;
